import { configureStore } from '@reduxjs/toolkit';
import DialogOpenState from './reducers/dialogSlice';
import UserReducer from './reducers/userSlice';
import FaqReducer from './reducers/faqSlice';
import ArticleReducer from './reducers/articleSlice';
import FeedbackReducer from './reducers/feedbackSlice';
import BookmarkReducer from './reducers/bookmarkSlice';
import GroupReducer from './reducers/groupSlice';
import PostReducer from './reducers/postSlice';
import topicReducer from './reducers/topicSlice';
import babyNamesReducer from './reducers/babyNamesSlice';
import blogReducer from './reducers/blogSlice';
import searchArticlesReducer from './reducers/searchArticleSlice';
import cousesReducer from './reducers/courseSlice';
import policyReducer from './reducers/policySlice';
import termsOfReducer from './reducers/termsUseSlice';
import aboutUsReducer from './reducers/aboutUsSlice';
import contactUsReducer from './reducers/contactSlice';
export const store = configureStore({
  reducer: {
    dialogOpenState: DialogOpenState,
    userSlice: UserReducer,
    faqs: FaqReducer,
    article: ArticleReducer,
    feedback: FeedbackReducer,
    bookmark: BookmarkReducer,
    group: GroupReducer,
    post: PostReducer,
    topic: topicReducer,
    babyNames: babyNamesReducer,
    blog: blogReducer,
    searchArticles: searchArticlesReducer,
    courses: cousesReducer,
    policy: policyReducer,
    termsUse: termsOfReducer,
    aboutUs: aboutUsReducer,
    contactUs: contactUsReducer,
  },
});

export default store;
